// extracted by mini-css-extract-plugin
export var cancelButton = "_np-5";
export var content = "_np-3";
export var createButton = "_np-6";
export var drawerContainer = "_np-0";
export var footer = "_np-2";
export var header = "_np-1";
export var orderFormColumn = "_np-4";